import { useEffect } from "react";

import { BookingAnalyticsEvent } from "@/constants/analytics/Analytics";
import { BookingStepBaseTestIDMap } from "@/constants/Booking";
import { CTAText } from "@/constants/Schedule";
import { router } from "@/crossPlatform/expo-router";
import useBookingAnalytics from "@/hooks/useBookingAnalytics";
import ModalFooter from "@/ui/composed/modal/ModalFooter";
import { FAIconName } from "@/ui/core";

interface BookingModalFooterProps {
  isFinalStep?: boolean;
  isFirstStep?: boolean;
  isForwardNavigationDisabled?: boolean;
  isLoading?: boolean;
  onBackwardPress?: () => void;
  onForwardPress: () => void;
  step: BookingStep;
}

const BookingModalFooter = ({
  isFinalStep,
  isFirstStep,
  isForwardNavigationDisabled,
  isLoading,
  onBackwardPress,
  onForwardPress,
  step,
}: BookingModalFooterProps) => {
  const { trackEvent, trackStepPageView } = useBookingAnalytics();

  useEffect(() => {
    trackStepPageView(step);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const baseTestID = BookingStepBaseTestIDMap[step];
  const handleBackwardPress = () => {
    if (isFirstStep) {
      trackEvent({ event: BookingAnalyticsEvent.Close, source: step });
      router.dismiss();
      return;
    }

    trackEvent({ event: BookingAnalyticsEvent.Back, source: step });
    onBackwardPress?.();
  };

  const handleForwardPress = () => {
    onForwardPress();
    if (isFinalStep) {
      trackEvent({ event: BookingAnalyticsEvent.ConfirmBooking, source: step });
      return;
    }

    trackEvent({ event: BookingAnalyticsEvent.Continue, source: step });
  };

  return (
    <ModalFooter
      isLeftButtonHidden={isLoading}
      isLoading={isLoading}
      isRightButtonDisabled={isForwardNavigationDisabled}
      leftButtonType={isFirstStep ? "cancel" : "back"}
      onLeftButtonPress={handleBackwardPress}
      onRightButtonPress={handleForwardPress}
      rightButtonLabel={isFinalStep ? "Book appointment" : CTAText.Continue}
      rightButtonLeftIcon={isFinalStep ? FAIconName.Check : undefined}
      rightButtonRightIcon={isFinalStep ? undefined : FAIconName.ChevronRight}
      testID={baseTestID}
    />
  );
};

export type { BookingModalFooterProps };
export default BookingModalFooter;
